import React from 'react';
import { BlockZeroCoins } from './styles';
import { Icon } from '@gerdau/hefesto/Icon';
import { Button } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../routes';

const LoyaltyNoCoins: React.FC = () => {
  const history = useHistory();
  return (
    <BlockZeroCoins>
      <Icon option="DollarSign" variant="primary" size="full" />
      <p className="subtitle">Você ainda não tem pontos disponíveis.</p>
      <p className="subtitle">
        Que tal realizar uma compra para ganhar pontos?
      </p>
      <Button
        onClick={() => {
          history.push(`${ERoutes.PURCHASE}`);
        }}
        name="orders"
      >
        Novo Pedido
      </Button>
    </BlockZeroCoins>
  );
};

export default LoyaltyNoCoins;
